import { render } from "./FormConsent.vue?vue&type=template&id=60e2d72e&scoped=true&ts=true"
import script from "./FormConsent.vue?vue&type=script&lang=ts"
export * from "./FormConsent.vue?vue&type=script&lang=ts"

import "./FormConsent.vue?vue&type=style&index=0&id=60e2d72e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e2d72e"]])

export default __exports__